import {IPrdictorStore} from "apps/BUDWEISERPOTM/modules/types/store";

export const getChecksums = (state: IPrdictorStore) => state.liveScoring.checksums;
